__turbopack_context__.v({
  "action": "TomorrowAuction-module__zerZ9q__action",
  "closed": "TomorrowAuction-module__zerZ9q__closed",
  "cutLine": "TomorrowAuction-module__zerZ9q__cutLine",
  "section": "TomorrowAuction-module__zerZ9q__section",
  "skeleton": "TomorrowAuction-module__zerZ9q__skeleton",
  "standings": "TomorrowAuction-module__zerZ9q__standings",
  "stat": "TomorrowAuction-module__zerZ9q__stat",
  "statEmpty": "TomorrowAuction-module__zerZ9q__statEmpty",
  "statFigure": "TomorrowAuction-module__zerZ9q__statFigure",
  "statLabel": "TomorrowAuction-module__zerZ9q__statLabel",
  "stats": "TomorrowAuction-module__zerZ9q__stats",
  "statsRow": "TomorrowAuction-module__zerZ9q__statsRow",
  "status": "TomorrowAuction-module__zerZ9q__status",
  "terms": "TomorrowAuction-module__zerZ9q__terms",
});
